import React from 'react';
import {
    BodySmallEmphasized,
    Button,
    ButtonSize,
    ButtonVariant,
    isWeb,
    SafeAreaView,
    useThemeColors,
    YStack,
} from 'smoothie';

interface ErrorViewProps {
    message?: string;
    onExit: () => void;
}

export const ErrorView = ({ message, onExit }: ErrorViewProps) => {
    const { getColor } = useThemeColors();

    return (
        <SafeAreaView style={{ flex: 1, backgroundColor: getColor('$white') }}>
            <YStack flex={1} alignItems="center" padding={20}>
                <BodySmallEmphasized
                    color="$red1100"
                    marginTop={isWeb ? '30vh' : 'auto'}
                    marginBottom={isWeb ? '10vh' : 'auto'}
                >
                    {message ?? 'Oops! Something went wrong.'}
                </BodySmallEmphasized>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Go back"
                    buttonProps={{ maxWidth: 400 }}
                    onPress={onExit}
                />
            </YStack>
        </SafeAreaView>
    );
};
